import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer style={{
      backgroundColor: 'var(--bg-primary)',
      borderTop: `1px solid var(--border)`,
      marginTop: 'auto'
    }}>
      <div className="container">
        {/* Upper Section - Two Columns */}
        <div style={{
          padding: '60px 0 40px',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '60px'
        }}>
          {/* Column 1 - About ImanVerse */}
          <div>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '20px',
              color: 'var(--text-primary)'
            }}>
              About ImanVerse
            </h3>
            <div style={{
              color: 'var(--text-secondary)',
              fontSize: '15px',
              lineHeight: '1.7',
              opacity: '0.85'
            }}>
              <p style={{ marginBottom: '16px' }}>
                ImanVerse is a calm digital space created to inspire faith, learning, and reflection.
              </p>
              <p>
                Our goal is to nurture understanding through simplicity, clarity, and truth.
              </p>
            </div>
          </div>

          {/* Column 2 - Support */}
          <div>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '20px',
              color: 'var(--text-primary)'
            }}>
              Support Our Mission
            </h3>
            <div style={{
              color: 'var(--text-secondary)',
              fontSize: '15px',
              lineHeight: '1.7',
              opacity: '0.85',
              marginBottom: '20px'
            }}>
              <p style={{ marginBottom: '12px' }}>
                Your support helps us maintain and improve this platform for the global Muslim community.
              </p>
              <p>
                <strong>Contact:</strong> md.shafee05s@gmail.com
              </p>
            </div>
            <Link 
              to="/donate" 
              className="btn-primary" 
              style={{ 
                textDecoration: 'none',
                display: 'inline-block'
              }}
            >
              Support ImanVerse
            </Link>
          </div>
        </div>

        {/* Divider Line */}
        <div style={{
          borderTop: `1px solid var(--border)`,
          opacity: '0.3'
        }}></div>

        {/* Bottom Row */}
        <div style={{
          padding: '24px 0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          {/* Left - Legal Links */}
          <div style={{ display: 'flex', gap: '20px' }}>
            <Link 
              to="/terms" 
              style={{
                color: 'var(--text-secondary)',
                fontSize: '13px',
                textDecoration: 'none',
                opacity: '0.8'
              }}
            >
              Terms of Use
            </Link>
            <Link 
              to="/privacy" 
              style={{
                color: 'var(--text-secondary)',
                fontSize: '13px',
                textDecoration: 'none',
                opacity: '0.8'
              }}
            >
              Privacy Policy
            </Link>
            <Link 
              to="/about" 
              style={{
                color: 'var(--text-secondary)',
                fontSize: '13px',
                textDecoration: 'none',
                opacity: '0.8'
              }}
            >
              About Creator
            </Link>
          </div>

          {/* Right - Copyright */}
          <div style={{
            color: 'var(--text-secondary)',
            fontSize: '13px',
            opacity: '0.8'
          }}>
            © 2025 ImanVerse. All rights reserved.
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          footer .container > div:first-child {
            grid-template-columns: 1fr;
            gap: 40px;
            padding: 40px 0 30px;
          }
          
          footer .container > div:last-child {
            flex-direction: column;
            gap: 16px;
            text-align: center;
          }
        }
        
        @media (max-width: 480px) {
          footer .container {
            padding: 0 20px;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;